import React from 'react'
import PropTypes from 'prop-types'

import styles from './TableGroupCell.css'

const propTypes = {
    children: PropTypes.node.isRequired,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
}

const TableGroupCell = (props) => (
    <div className={styles.cellGroup} style={{ width: props.width }}>{props.children}</div>
)

TableGroupCell.propTypes = propTypes

export default TableGroupCell



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Table/TableGroupCell/TableGroupCell.jsx